// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExcelFilledSvg from "@fishx/icons-svg/es/asn/FileExcelFilled";
import FishxIcon from '../components/FishxIcon';

var FileExcelFilled = function FileExcelFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelFilledSvg
  }));
};

FileExcelFilled.displayName = 'FileExcelFilled';
export default React.forwardRef(FileExcelFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileExcelFilled.js
// module id = 2694
// module chunks = 0